import { ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
var DEFAULT_PRIMARY = '#FED33C';
var DEFAULT_SECONDARY = '#F16821';
var ImageLoaderComponent = /** @class */ (function () {
    function ImageLoaderComponent(store) {
        this.store = store;
        this.showPlaceholder = true;
        /**
         * Whether or not to show the branded background gradient as placholder.
         * Set to false if you are styling the image-loader from another component's styles.
         */
        this.title = '';
        this.background = true;
        this.contain = false;
        this.imageLoaded = false;
        this.init = false;
        this.primary = DEFAULT_PRIMARY;
        this.secondary = DEFAULT_SECONDARY;
    }
    Object.defineProperty(ImageLoaderComponent.prototype, "image", {
        get: function () {
            return this._image;
        },
        set: function (data) {
            var newImage;
            if (!data) {
                newImage = false;
            }
            else {
                if (Array.isArray(data)) {
                    newImage = data[0];
                }
                else {
                    newImage = data;
                }
            }
            if (newImage !== this._image) {
                this._image = newImage;
                this.imageLoaded = false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageLoaderComponent.prototype, "hostBackground", {
        get: function () {
            return this.background ? this.gradient : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageLoaderComponent.prototype, "localBackground", {
        get: function () {
            return this.image && this.imageLoaded ? "url(" + this.image + ")" : "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageLoaderComponent.prototype, "gradient", {
        get: function () {
            return this.showPlaceholder
                ? "linear-gradient(to top right, " + (this.primary || DEFAULT_PRIMARY) + ", " + (this.secondary ||
                    DEFAULT_SECONDARY) + ")"
                : 'transparent';
        },
        enumerable: true,
        configurable: true
    });
    ImageLoaderComponent.prototype.ngAfterContentInit = function () {
        if (this.imageLoaded)
            return;
        this.init = true;
    };
    ImageLoaderComponent.prototype.setImageLoaded = function () {
        this.imageLoaded = true;
    };
    Object.defineProperty(ImageLoaderComponent.prototype, "brandedPlaceholder", {
        get: function () {
            return "url(" + this.placeholder + ")";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageLoaderComponent.prototype, "defaultPlaceholder", {
        get: function () {
            return "url('assets/svg/logo-square-light.svg')";
        },
        enumerable: true,
        configurable: true
    });
    return ImageLoaderComponent;
}());
export { ImageLoaderComponent };
